import { GlButton, GlIcon, GlLink, GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { __, sprintf } from '~/locale';
import { handleLocationHash, isLoggedIn } from '~/lib/utils/common_utils';
import { renderGFM } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
import { logError } from '~/lib/logger';
import { captureException } from '~/sentry/sentry_browser_wrapper';
import { getRefType } from '../../utils/ref_type';
import getRefMixin, { refApolloQuery } from '../../mixins/get_ref';
import projectPathQuery from '../../queries/project_path.query.graphql';
import blobEditQuery from '../../queries/blob_edit.query.graphql';
import readmeQuery from '../../queries/readme.query.graphql';
export default {
    name: 'PreviewIndex',
    components: {
        GlButton,
        GlIcon,
        GlLink,
        GlLoadingIcon
    },
    directives: {
        SafeHtml
    },
    mixins: [
        getRefMixin
    ],
    apollo: {
        // Re-declared from getRefMixin: Vue 3 drops mixin apollo entries when the
        // component defines its own apollo block (see mixins/get_ref.js).
        ref: refApolloQuery,
        readme: {
            query: readmeQuery,
            variables () {
                return {
                    url: this.blob.webPath
                };
            }
        },
        projectPath: {
            query: projectPathQuery
        },
        editBlob: {
            query: blobEditQuery,
            variables () {
                return {
                    projectPath: this.projectPath,
                    filePath: this.blob.path,
                    ref: this.ref,
                    refType: getRefType(this.refType)
                };
            },
            skip () {
                return !isLoggedIn() || !this.projectPath || !this.ref || !this.blob.path;
            },
            update: (data)=>data.project?.repository?.blobs?.nodes?.[0] ?? null,
            error (error) {
                logError(`Unexpected error while fetching editBlob query`, error);
                captureException(error);
            }
        }
    },
    inject: {
        refType: {
            default: null
        }
    },
    props: {
        blob: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            readme: null,
            projectPath: '',
            editBlob: null,
            ref: ''
        };
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.readme.loading;
        },
        editPath () {
            return this.editBlob?.canModifyBlob ? this.editBlob.editBlobPath : null;
        },
        editButtonAriaLabel () {
            return sprintf(__('Edit file %{fileName}'), {
                fileName: this.blob.name
            });
        }
    },
    watch: {
        readme (newVal) {
            if (newVal) {
                this.$nextTick(()=>{
                    handleLocationHash();
                    renderGFM(this.$refs.readme);
                });
            }
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'copy-code'
        ]
    }
};
